import React from 'react';
import './InputField.scss';

const InputField = ({
  id,
  type = 'text', // text, fullname, email, tel
  name,
  label,
  value,
  onChange,
  onBlur,
  required = false,
  placeholder = '',
  dataType,
  className = '',
  autoComplete = '',
  size = '310',
  dataComponent,
  isFullName = false,
  fullNameValues = { first: '', last: '' },
  fullNameOnChange
}) => {
  const baseClassName = 'form-textbox';
  const validationClass = required ? `validate[${type === 'email' ? 'Email,' : ''}required]` : '';
  const customClass = type === 'tel' ? 'mask-phone-number' : '';

  const renderInput = () => {
    if (isFullName) {
      return (
        <div data-wrapper-react="true">
          <span className="form-sub-label-container" style={{ verticalAlign: 'top' }} data-input-type="first">
            <input
              type="text"
              id={`first_${id}`}
              name={`${name}[first]`}
              className={`${baseClassName} ${validationClass}`}
              autoComplete={`section-input_${id} given-name`}
              size="10"
              placeholder="First Name"
              data-component="first"
              aria-labelledby={`label_${id}`}
              value={fullNameValues.first}
              onChange={(e) => fullNameOnChange('first', e.target.value)}
              required={required}
            />
          </span>
          <span className="form-sub-label-container" style={{ verticalAlign: 'top' }} data-input-type="last">
            <input
              type="text"
              id={`last_${id}`}
              name={`${name}[last]`}
              className={`${baseClassName} ${validationClass}`}
              autoComplete={`section-input_${id} family-name`}
              size="15"
              placeholder="Last Name"
              data-component="last"
              aria-labelledby={`label_${id}`}
              value={fullNameValues.last}
              onChange={(e) => fullNameOnChange('last', e.target.value)}
              required={required}
            />
          </span>
        </div>
      );
    }

    const inputProps = {
      type,
      id: type === 'tel' ? `input_${id}_full` : `input_${id}`,
      name,
      className: `${baseClassName} ${validationClass} ${customClass} ${className}`.trim(),
      autoComplete,
      style: { width: `${size}px` },
      size,
      placeholder,
      'data-component': dataComponent,
      'aria-labelledby': `label_${id}`,
      value,
      onChange,
      onBlur,
      required,
    };

    if (dataType) {
      inputProps['data-type'] = dataType;
    }

    return type === 'tel' ? (
      <span className="form-sub-label-container" style={{ verticalAlign: 'top' }}>
        <input {...inputProps} />
      </span>
    ) : (
      <input {...inputProps} />
    );
  };

  return (
    <li className="form-line jf-required input-question-wrapper" data-type={`control_${isFullName ? 'fullname' : type}`} id={id}>
      <label 
        className="form-label form-label-top form-label-auto input-question name-fields"  
        htmlFor={isFullName ? `first_${id}` : `input_${id}`} 
        id={`label_${id}`} 
        aria-hidden="false"
      >
        {label}
        {required && <span className="form-required">*</span>}
      </label>
      <div 
        id={`cid_${id}`} 
        className="form-input-wide" 
        data-layout={isFullName ? 'full' : 'half'}
      >
        {renderInput()}
      </div>
    </li>
  );
};

export default InputField; 